export const PersonalDetailsList = [
  {
    id: 0,
    title: "Name",
    text: "Daksh",
  },
  {
    id: 1,
    title: "Birthday",
    text: "1st May 2000",
  },
  {
    id: 2,
    title: "Age",
    text: "25",
  },
  {
    id: 3,
    title: "Degree",
    text: "B.E (IT)",
  },
  {
    id: 4,
    title: "Phone No",
    text: "+91 9173186323",
  },
  {
    id: 5,
    title: "Email",
    text: "pateldaksh1520@gmail.com",
  },
  {
    id: 6,
    title: "City",
    text: "Ahmedabad",
  },
  {
    id: 7,
    title: "State",
    text: "Gujarat",
  },
  {
    id: 8,
    title: "Country",
    text: "India",
  },
]
